import { gql } from "@apollo/client"

export const LOGIN_MUTATION = gql`
  mutation UserLogin($UserLoginInput: UserLoginInput!) {
    UserLogin(input: $UserLoginInput) {
      token
      status {
        success
        name
        detail
      }
    }
  }
`

export const REGISTER_MUTATION = gql`
  mutation UserRegister($UserRegisterInput: UserRegisterInput!) {
    UserRegister(input: $UserRegisterInput) {
      status {
        success
        name
        detail
      }
      person {
        id
        fullName
        code
        nickname
        email
        avatar
        urlAvatar
      }
    }
  }
`

export const FORGOT_PASSWORD_MUTATION = gql`
  mutation UserPasswdRecover($UserPasswdRecoverInput: UserPasswdRecoverInput!) {
    UserPasswdRecover(input: $UserPasswdRecoverInput) {
      status {
        success
        name
        detail
      }
    }
  }
`

export const RESET_PASSWORD_MUTATION = gql`
  mutation ResetPassword($token: String!, $password: String!) {
    resetPassword(token: $token, password: $password) {
      status {
        code
        message
        success
      }
    }
  }
`

export const GET_USER_INFO = gql`
  query UserInfo {
    UserInfo {
      User {
        id
        Person {
          id
          name
          firstSurname
          lastSurname
          fullName
          email
          phone
          emailValid
          documentNumber
          documentNumberType
          birthday
          active
          code
          categoryId
          created
          avatar
          urlAvatar
          PersonProfiles {
            profileId
          }
          Gender {
            name
          }
          Store {
            id
            name
            description
            logo
            urlLogo
            cover
            urlCover
            phone
            email
            active
            siteUrl
            facebookUrl
            instagramUrl
            twitterUrl
            youtubeUrl
            urlView
            urlTournaments
            urlPastTournaments
            Person {
              id
              fullName
              urlAvatar
              code
            }
            Address {
              id
              name
              address
              countryId
              regionId
              locationId
              Country {
                iso
                name
              }
              Region {
                fullName
              }
              Location {
                id
                name
              }
            }
            Level {
              name
            }
            StoreTournamentTypes {
              typeId
              quantity
            }
          }
          Address {
            id
            name
            address
            countryId
            regionId
            locationId
            modified
            Country {
              id
              name
              iso
            }
            Region {
              id
              name
              alias
              fullName
            }
            Location {
              id
              name
            }
          }
        }
      }
    }
  }
`

export const ADDRESS_CONFIRM_MUTATION = gql`
  mutation AddressConfirm($input: AddressConfirmInput!) {
    AddressConfirm(input: $input) {
      status {
        success
        name
        detail
      }
      address {
        id
        countryId
        regionId
        locationId
        modified
      }
    }
  }
`
